import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import ProvidersList from 'providers/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const ProvidersListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <ProvidersList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.providers_clients.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('providers.title')}
          icon={'shopping-cart'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.providers_clients.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'providers/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <ProvidersList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <ProvidersList.Table
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </ProvidersList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(ProvidersListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/ProvidersListView.js